import { ReactElement, useEffect } from "react";
import styles from "../../InternationalSolutionsPage.module.css";
import EORPromoImage from "../../images/eor-promo-banner.png";
import EORPromoPriceCard from "pages/international-solutions/components/Cards/EORPromoPriceCard";
import { EORPromoFAQ } from "pages/international-solutions/components/FAQ/EORPromoFAQ";
import {
  CUSTOMER_IO_PAGEVIEW_EVENT,
  sendCustomerIOEvent,
} from "app/customer-io";
import { oktaAuth, pkceIsEnabled } from "app/okta";
import { useGetCompanyDisplayQuery } from "types/generated/operations";
import { trackPdpEvent } from "app/market-expansion/event-tracking";

const EORPromo = (): ReactElement => {
  const {
    container,
    column1,
    column2,
    divWrapper,
    mdFont,
    mdGap,
    lgGap,
    lgHead,
    hr,
    listItems,
  } = styles;

  const { data: memberData } = useGetCompanyDisplayQuery();

  useEffect(() => {
    const accessToken = pkceIsEnabled() ? oktaAuth.getAccessToken() : "";

    // memberData to be available to avoid redundant calls
    if (!memberData?.authenticatedMember) return;

    const memberUuid = memberData?.authenticatedMember.uuid ?? "";
    const companyUuid = memberData?.authenticatedMember.company.uuid ?? "";

    sendCustomerIOEvent(
      {
        event_type: CUSTOMER_IO_PAGEVIEW_EVENT,
        member_uuids: [memberUuid],
        company_uuids: [companyUuid],
        data: { page_url: window.location.href },
      },
      accessToken
    );

    trackPdpEvent({
      actorId: memberUuid,
      companyId: companyUuid,
      pageDomain: window.location.hostname,
      pagePath: window.location.pathname,
    });
  }, [memberData]);

  return (
    <>
      <div className={container}>
        <div className={column1}>
          <img src={EORPromoImage} alt="" />
          <div className={`${divWrapper} ${lgGap}`}>
            <div className={lgHead}>
              Claim your 12 months of discounted EOR - here's how
            </div>
            <div className={mdFont}>
              At Justworks, we're committed to making international hiring
              accessible for small businesses like yours! As a valued PEO
              customer, we're offering you an{" "}
              <b>
                exclusive, limited-time discount of $299 per employee per month
              </b>{" "}
              (reduced from $599) for the first 12 months as an Employer of
              Record (EOR) customer.
            </div>
            <div>
              This offer is only available to Justworks PEO customers for a
              limited time, so don't miss out. Our team is available to help you
              take advantage of this opportunity while it lasts.
            </div>
          </div>
          <hr className={hr}></hr>
          <div className={`${divWrapper} ${mdGap}`}>
            <div className={lgHead}>Key Features</div>
            <div>
              <ul className={`${listItems} ${mdFont}`}>
                <li>No setup fees and no minimums</li>
                <li>Easy onboarding workflows</li>
                <li>Compliance expertise from an award-winning support team</li>
                <li>Localized employee benefits</li>
              </ul>
            </div>
          </div>
          <div className={`${divWrapper} ${mdGap}`}>
            <EORPromoFAQ />
          </div>
        </div>
        <div className={column2}>
          <EORPromoPriceCard />
        </div>
      </div>
    </>
  );
};

export default EORPromo;
